import { IconButton, Stack, SvgIcon, Typography } from '@mui/material'
import { ModelListRowModel } from '../../types'
import { ItemTile } from '~/ui/components/ItemTile'
import { IconChevronRight, IconSeparator, IconShoppingBag } from '@tabler/icons-react'
import { editVisitorPath } from '~/features/routes'
import { format } from 'date-fns'
import { Link } from 'react-router'
import { entries } from 'remeda'
import { useMemo } from 'react'
import { EmptyStateRadar } from '~/ui/components/EmptyState/EmptyStateRadar'

export const SalesDetails = ({ data }: { data: ModelListRowModel }) => {
  const salesMap = useMemo(() => {
    return data.inventory
      .filter((inv) => !!inv.sales)
      .reduce<
        Record<number, { sizes: number[]; created_at: string; total: number; agency: string }>
      >((acc, inv) => {
        if (inv.sales) {
          const existing = acc[inv.sales.id]
          acc[inv.sales.id] = {
            sizes: existing ? [...existing.sizes, inv.size] : [inv.size],
            created_at: inv.sales.created_at,
            total: inv.sales.total,
            agency: inv.sales.agency,
          }
        }
        return acc
      }, {})
  }, [data.inventory])
  return (
    <Stack spacing={1} useFlexGap sx={{ height: 1 }}>
      {entries(salesMap).length > 0 ? (
        entries(salesMap).flatMap(([salesId, sales]) => {
          return (
            <ItemTile
              key={salesId}
              Icon={IconShoppingBag}
              primaryButton={
                <IconButton
                  component={Link}
                  to={editVisitorPath(parseInt(salesId))}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconChevronRight />
                </IconButton>
              }
            >
              <Stack>
                <Stack direction="row" spacing={1} useFlexGap sx={{ alignItems: 'center' }}>
                  <Typography variant="subtitle1">Sale #{salesId}</Typography>
                </Stack>
                <Stack
                  direction="row"
                  spacing={0.5}
                  useFlexGap
                  divider={
                    <SvgIcon fontSize="small" sx={{ color: 'text.secondary' }}>
                      <IconSeparator />
                    </SvgIcon>
                  }
                >
                  <Typography variant="caption" color="text.secondary">
                    {format(sales.created_at, 'dd/MM/yyyy')}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {sales.agency}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Sizes: {sales.sizes.join(', ')}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {sales.total} CZK
                  </Typography>
                </Stack>
              </Stack>
            </ItemTile>
          )
        })
      ) : (
        <EmptyStateRadar title="No sales found" description="This model has no sales" />
      )}
    </Stack>
  )
}
